module.exports = __webpack_public_path__ + "img/矩形 2622.f61f4d83.png";